
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { GetServerSidePropsContext, GetServerSidePropsResult, NextPage } from 'next';
import { Play as PlayApi } from 'typings/api';
import Watch from 'pages/watch-online/[slug]';
import { withForcePlanToLoggedInUnsubs } from 'context';
import { authorizeUserServerSide } from 'api/firebaseAdmin';
import { StaticPathParams } from 'typings/staticPaths';
import { createRedirectIfNeeded, Permalink } from 'helpers';
import Play from 'models/Play';

interface Props {
  play: PlayApi;
  countryCode: string;
}

const WatchTrailer: NextPage<Props> = (props) => {
  return <Watch {...props} isPreview={true} />;
};

 async function _getServerSideProps(
  ctx: GetServerSidePropsContext<StaticPathParams>,
): Promise<GetServerSidePropsResult<Props>> {
  const { locale, apiClient, countryCode } = await authorizeUserServerSide(ctx);

  const playSlug = ctx.query?.slug as string;

  const redirect = createRedirectIfNeeded(ctx, locale);
  if (redirect) {
    return redirect;
  }

  try {
    // PLAY check
    const [id, ...slug] = (playSlug as string).split('-');
    let res: PlayApi;

    // old urls without ids
    if (isNaN(+id)) {
      res = await apiClient.getPlayDetail(playSlug);
    } else {
      res = await apiClient.getPlayDetail(+id);
    }
    const play = Play.fromJSON(res);
    const localisedSlug = play.localisedSlug(locale);

    if (slug.join('-') !== localisedSlug) {
      return {
        redirect: {
          permanent: true,
          destination: Permalink.preview({ ...play, slug: localisedSlug }, locale),
        },
      };
    }

    return {
      props: {
        play: res,
        countryCode,
      },
    };
  } catch (e) {
    return {
      notFound: true,
    };
  }
}

export default withForcePlanToLoggedInUnsubs(WatchTrailer);


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/preview/[slug]/index',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  